/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Agenda_TodayInputs */

const cs_nav_agenda_today = /** @type {(inputs: Nav_Agenda_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dnešní agenda`)
};

const en_nav_agenda_today = /** @type {(inputs: Nav_Agenda_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's agenda`)
};

/**
* | output |
* | --- |
* | "Today's agenda" |
*
* @param {Nav_Agenda_TodayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_agenda_today = /** @type {((inputs?: Nav_Agenda_TodayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Agenda_TodayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_agenda_today(inputs)
	return cs_nav_agenda_today(inputs)
});